
import { doc, updateDoc, serverTimestamp, setDoc, collection, addDoc } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { WearableData } from '../types';

const PROVIDER_CONFIGS: Record<string, { authUrl: string, clientId: string }> = {
  fitbit: { authUrl: 'https://www.fitbit.com/oauth2/authorize', clientId: 'YOUR_FITBIT_ID' },
  google: { authUrl: 'https://accounts.google.com/o/oauth2/v2/auth', clientId: 'YOUR_GOOGLE_ID' },
  garmin: { authUrl: 'https://connect.garmin.com/oauthConfirm', clientId: 'YOUR_GARMIN_ID' },
  apple: { authUrl: 'bridge://healthkit', clientId: 'ios-internal' },
  samsung: { authUrl: 'bridge://samsung-health', clientId: 'samsung-internal' }
};

export const connectProvider = (provider: string) => {
  const config = PROVIDER_CONFIGS[provider];
  if (!config) {
    console.warn(`No configuration found for wearable provider: ${provider}`);
    return false;
  }
  
  if (config.authUrl.startsWith('bridge://')) {
    console.log(`Initializing local bridge for ${provider}...`);
    // In a real app, this would trigger native HealthKit/Samsung Health permissions
    alert(`Connecting to ${provider} local health data...`);
    return true;
  }

  // In production, this would redirect to OAuth flow
  console.log(`Connecting to ${provider} via ${config.authUrl}`);
  window.open(config.authUrl, '_blank');
  return true;
};

export const syncHealthData = async (userId: string, data: Partial<WearableData>) => {
  const userRef = doc(db, "users", userId);
  const healthRef = collection(db, "users", userId, "healthHistory");
  
  const today = new Date().toISOString().split('T')[0];
  
  // Update current state
  await updateDoc(userRef, {
    "wearable.steps": data.steps || 0,
    "wearable.caloriesBurned": data.caloriesBurned || 0,
    "wearable.heartRate": data.heartRate || 0,
    "wearable.lastSync": serverTimestamp(),
    "wearable.provider": data.provider || 'manual'
  });

  // Log to history for charts
  await addDoc(healthRef, {
    date: today,
    ...data,
    timestamp: serverTimestamp()
  });
};

export const calculateCalorieBalance = (intake: number, burned: number, bmr: number = 1800) => {
  // Intake (from Diet) - Burned (Basal + Active)
  return intake - (bmr + burned);
};
